import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/public/ui";

export default function Blog() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("");
  useEffect(() => {
    api.get("/blog_posts").then(({ data }) => setItems(data)).catch(() => {});
    api.get("/blog_categories").then(({ data }) => setCats(data)).catch(() => {});
  }, []);
  const filtered = active ? items.filter((p) => p.category === active) : items;
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">Blog & Actualités</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head">Nos articles</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">Conseils, tendances et actualités technologiques.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-wrap gap-2 mb-8">
          <button onClick={() => setActive("")} className={`px-4 py-2 rounded-full text-sm font-medium ${!active ? "bg-[#0F2A6B] text-white" : "bg-white border border-slate-200 text-slate-600"}`}>Tous</button>
          {cats.map((c) => (<button key={c.id} onClick={() => setActive(c.name)} className={`px-4 py-2 rounded-full text-sm font-medium ${active === c.name ? "bg-[#0F2A6B] text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-[#0F2A6B]/30"}`}>{c.name}</button>))}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block rounded-2xl overflow-hidden bg-white border border-slate-200 hover:shadow-lg transition-all h-full">
                <div className="h-48 overflow-hidden"><img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="font-mono text-[#4CB944] uppercase">{p.category}</span>
                    {p.read_time && <span className="flex items-center gap-1 text-slate-400"><Clock className="w-3 h-3" />{p.read_time} min</span>}
                  </div>
                  <h3 className="mt-2 font-semibold text-slate-900 font-head line-clamp-2 group-hover:text-[#0F2A6B]">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-500 line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
          {filtered.length === 0 && <p className="text-slate-500">Aucun article publié.</p>}
        </div>
      </section>
    </div>
  );
}
